import { getGraphQLAccountSourceFromSourceListStore } from 'account-utils';
import { getSelectedSourceId } from 'owa-account-source-list';
import initializeAccountStore from '../actions/initializeAccountStore';

let initializeAccountsStorePromise: Promise<boolean> | undefined = undefined;

export function initializeAccountsStore(): Promise<boolean> {
    if (!initializeAccountsStorePromise) {
        initializeAccountsStorePromise = initializeAccountsStoreInternal();
    }

    return initializeAccountsStorePromise;
}

async function initializeAccountsStoreInternal() {
    const accounts = getGraphQLAccountSourceFromSourceListStore();
    initializeAccountStore(accounts, getSelectedSourceId());
    return Promise.resolve(true);
}
